@let twoFactorAuthEnabledStatus = twoFactorAuthService.enabledStatus$ | async;

<fcom-modal
  [open]="modalOpen()"
  [buttons]="currentStep() === SoftEnforceMfaFlowStep.MfaEnabled ? ModalButtons.CLOSE : ModalButtons.CONTINUE_CANCEL"
  [fitToContent]="true"
  [overlayClickable]="false"
  [closeOnContinue]="false"
  [title]="modalTitleLabelKey() | finLocalization"
  [loading]="twoFactorAuthEnabledStatus.isLoading"
  [confirmTranslationKey]="confirmButtonTextLabelKey()"
  [cancelTranslationKey]="cancelButtonTextLabelKey()"
  (close)="closeModal()"
  (confirm)="executeNextAction()"
>
  <div class="flex flex--column pr-medium-x ps-large-y">
    @switch (currentStep()) {
      @case (SoftEnforceMfaFlowStep.ImproveSecurity) {
        <p
          [innerHTML]="'login.softEnforceMfa.improveYourAccountSecurityDescription' | finLocalization | finSafe: 'html'"
        ></p>
        <fcom-link
          class="block ms-small-t external-link bold-type"
          [href]="'login.softEnforceMfa.whatIsTwoFactorAuthButton.link.url' | finLocalization"
          [openInNewTab]="true"
          [external]="true"
          [icon]="{ name: SvgLibraryIcon.EXTERNAL_TAB, position: IconPosition.RIGHT }"
          (beforeNavigation)="onWhatIsTwoFactorAuthButtonBeforeNavigation($event)"
          >{{ 'login.softEnforceMfa.whatIsTwoFactorAuthButton.text' | finLocalization }}
        </fcom-link>

        @if (!!requestError()) {
          <fcom-notification
            aria-live="polite"
            class="mr-xsmall-t"
            [theme]="NotificationTheme.ALERT"
            [layout]="NotificationLayout.BLOCK"
            [isClosable]="true"
            [i18n]="{ closeAriaLabel: 'plus.profile.closeNotification' }"
            (closeClick)="onCloseRequestError()"
            data-testid="soft-enforce-mfa-improve-security-error-notification"
          >
            {{ 'plus.profile.twoFactorAuthFailed' | finLocalization }}
          </fcom-notification>
        }
      }
      @case (SoftEnforceMfaFlowStep.EmailVerification) {
        <fin-loyalty-email-change-verification-mfa-form
          [inModalLayout]="true"
          [forceSetEmailMfa]="true"
          [submitEmailVerification$]="submitEmailVerification$"
          [trackElementNamePrefix]="trackElementNamePrefix"
          [trackExtraEmailVerificationCodeEvents]="true"
          (emailVerificationResult)="onEmailVerificationResult($event)"
        />
      }
      @case (SoftEnforceMfaFlowStep.MfaEnabled) {
        <fcom-icon class="circle icon-xxlarge flex--self-center" [name]="SvgLibraryIcon.CHECKMARK_BLOCK" />

        <p
          [innerHTML]="'login.softEnforceMfa.twoFactorAuthEnabledDescription' | finLocalization | finSafe: 'html'"
          class="ms-medium-t"
          (click)="onClickWithPossibleInternalLink($event)"
        ></p>
      }
    }
  </div>
</fcom-modal>
